import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import Icon from '../../../Assets/Icon/CustomIcon';

export default function ComboBottomSheet({
  items = [],
  value,
  onChange,
  placeholder = '선택하세요',
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedItem = items.find((i) => i.value === value);

  return (
    <Box ref={ref} sx={{ position: 'relative', width: '100%' }}>
      <Box
        onClick={() => !disabled && setOpen(!open)}
        sx={{
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '8px ',
          background: '#fff',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography sx={{ fontSize: '14px' }}>
          {selectedItem ? selectedItem.name : placeholder}
        </Typography>
        <Icon.ArrowDropDown
          style={{
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
          }}
        />
      </Box>

      {open && (
        <Box
          sx={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            border: '1px solid #ddd',
            borderRadius: '8px',
            background: '#fff',
            zIndex: 1000,
            mt: 1,
            maxHeight: '200px',
            overflowY: 'auto',
          }}
        >
          {items.map((item) => (
            <Box
              key={item.value}
              onClick={() => {
                onChange(item.value);
                setOpen(false);
              }}
              sx={{
                padding: '10px',
                cursor: 'pointer',
                '&:hover': { background: '#f0f0f0' },
                fontSize: '14px',
              }}
            >
              {item.name}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
